import type { TomoContent } from '../types/content';
import { TOMO_IMAGES } from './images';

export const tomos: TomoContent[] = [
  {
    number: '01',
    label: 'TOMO 01',
    title: 'DEFENSA Y CONTROL',
    headline: 'CONSTRUYE PRIMERO AL JUGADOR QUE SABE SOBREVIVIR AL PUNTO.',
    copy: [
      'La defensa no consiste simplemente en devolver la pelota.',
      'Este tomo construye la base técnica que permite al alumno defender con intención, recuperar posición y preparar el momento de pasar al ataque.'
    ],
    features: [
      'Empuñadura continental',
      'Ready Position',
      'Pared de fondo',
      'Pared lateral',
      'Doble pared',
      'Globo como arma táctica',
      'Sistema defensivo en pareja',
      'Efecto goma'
    ],
    destacado:
      'OBJETIVO: que tus alumnos lleguen al final de la clase sabiendo defender con intención, no solo devolver bolas.',
    imageLabel: 'Tomo 1 — Defensa y Control',
    imageUrl: TOMO_IMAGES.tomo1
  },
  {
    number: '02',
    label: 'TOMO 02',
    title: 'ATAQUE Y DEFINICIÓN',
    headline: 'LLEGAR A LA RED ES FÁCIL. SABER QUÉ HACER ALLÍ ES OTRA HISTORIA.',
    copy: [
      'Una vez ganada la red, el alumno necesita aprender a mantenerla, generar presión y reconocer cuándo puede cerrar el punto.'
    ],
    features: ['Volea de control', 'Bandeja profunda', 'Víbora', 'Remate', 'X3', 'X4', 'Dejada táctica'],
    destacado:
      'OBJETIVO: que tus alumnos suban a la red y sepan exactamente qué hacer ahí, no solo esperar a ver qué pasa.',
    imageLabel: 'Tomo 2 — Ataque y Definición',
    imageUrl: TOMO_IMAGES.tomo2
  },
  {
    number: '03',
    label: 'TOMO 03',
    title: 'TÁCTICA Y ESTRATEGIA',
    headline: 'CONVIERTE "PEGADORES" EN JUGADORES QUE ENTIENDEN LA PISTA.',
    copy: [
      'Porque pegar mejor no siempre significa jugar mejor.',
      'Este tomo introduce las decisiones que convierten la técnica en juego real.'
    ],
    features: [
      'Regla de los 3 golpes',
      'Las 3 líneas de juego',
      'Centro, cruzado y paralelo',
      'Lectura del rival',
      'Nevera táctica',
      'Comunicación en pareja',
      'Gestión de tie-breaks',
      'Decisiones bajo presión'
    ],
    destacado:
      'OBJETIVO: que tus alumnos empiecen a tomar decisiones en pista en lugar de reaccionar por impulso.',
    imageLabel: 'Tomo 3 — Táctica y Estrategia',
    imageUrl: TOMO_IMAGES.tomo3
  },
  {
    number: '04',
    label: 'TOMO 04',
    title: 'METODOLOGÍA Y PLANIFICACIÓN',
    headline: 'AQUÍ EMPIEZA A DESAPARECER LA IMPROVISACIÓN.',
    copy: [
      'Puedes conocer perfectamente una bandeja y aun así no saber cómo organizar una clase de cuatro alumnos durante 60 minutos.',
      'Este tomo trabaja el sistema detrás de la sesión.'
    ],
    features: [
      'Estructura de sesión en 5 bloques',
      'Gestión del tiempo',
      'Grupos heterogéneos',
      'Niveles mixtos',
      'Drills circulares',
      'Intensidad de trabajo',
      'Diseño de ejercicios',
      'Progresiones lógicas'
    ],
    featuredBlock: ['NO SOLAMENTE QUÉ ENSEÑAR.', 'CÓMO ENSEÑARLO.'],
    destacado:
      'OBJETIVO: que cada clase tuya tenga un hilo conductor que el alumno perciba aunque no sepa que existe.',
    imageLabel: 'Tomo 4 — Metodología y Planificación',
    imageUrl: TOMO_IMAGES.tomo4
  },
  {
    number: '05',
    label: 'TOMO 05',
    title: 'EL TEMPLO',
    subLabel: 'MENTALIDAD · FÍSICO · NEGOCIO',
    headline: 'EL TRABAJO DEL MONITOR NO TERMINA CUANDO SALE DE LA PISTA.',
    copy: [
      'El último tomo amplía la mirada del monitor hacia las áreas que rodean a una buena clase y una carrera profesional sostenible.'
    ],
    features: [
      'Preparación física preventiva',
      'Hábitos y cuidado del jugador',
      'Psicología del alumno',
      'Comunicación',
      'Marca personal',
      'Redes sociales',
      'Gestión económica',
      'Organización de escuela'
    ],
    destacado:
      'OBJETIVO: que tu trabajo como monitor tenga un modelo de negocio detrás que lo haga sostenible a largo plazo.',
    imageLabel: 'Tomo 5 — Mentalidad, Físico y Negocio',
    imageUrl: TOMO_IMAGES.tomo5
  }
];
